import axios from "axios";
import swal from "sweetalert2";
import parse from "html-react-parser";

import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { globalState, accessTokenKey, baseUrl } from "../utils/config";

import ApplicationStatus from "./layouts/ApplicationStatus";
import Loader from "./layouts/Loader";

function ApplicationDetail() {
    const { id } = useParams();
    const [application, setApplication] = useState(null);
    const [loading, setLoading] = useState(false);

    async function onInit() {
        setLoading(true);

        try {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const formData = new FormData();
            formData.append("id", id);
            formData.append("time_zone", timeZone);

            const response = await axios.post(
                baseUrl + "/api/jobs/fetch-application",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                setApplication(response.data.application);
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setLoading(false);
        }
    }

    useEffect(function () {
        onInit();
    }, []);

    return (
        <>
            <div className="container-xxl py-5 bg-dark page-header mb-5">
                <div className="container my-5 pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">Application #{ id }</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/my-applied">My Applied</Link></li>
                            <li className="breadcrumb-item text-white active" aria-current="page">{ id }</li>
                        </ol>
                    </nav>
                </div>
            </div>

            { loading && (
                <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="container">
                        <div className="row gy-5 gx-4">
                            <div className="col-md-12 text-center">
                                <Loader />
                            </div>
                        </div>
                    </div>
                </div>
            ) }

            { application != null && (
                <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="container">
                        <div className="row gy-5 gx-4">
                            <div className="offset-md-4 col-md-6">
                                <div className="d-flex align-items-center mb-5">
                                    <div className="bg-light rounded p-5 wow slideInUp" data-wow-delay="0.1s">
                                        <h4 className="mb-4">Application Details</h4>
                                        <p><i className="fa fa-angle-right text-primary me-2"></i>Company: { application.company?.name }</p>
                                        
                                        <p><i className="fa fa-angle-right text-primary me-2"></i>
                                            CV: &nbsp;
                                            <a href={ application.cv?.path }
                                                target="_blank">{ application.cv?.title }</a>
                                        </p>

                                        <p><i className="fa fa-angle-right text-primary me-2"></i>
                                            Job: &nbsp;
                                            <Link to={ `/jobs/${ application.job?.id }` }>{ application.job?.title }</Link>
                                        </p>

                                        <p><i className="fa fa-angle-right text-primary me-2"></i>
                                            Status: &nbsp;
                                            <ApplicationStatus status={ application.status } />
                                        </p>
                                        
                                        <p><i className="fa fa-angle-right text-primary me-2"></i>Applied On: { application.created_at }</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) }
        </>
    );
}

export default ApplicationDetail;